import React, { FC } from 'react';
import { ButButtonProps } from './interfaces';
import { trackYandexGoal } from '../../../actions/utils';

const BuyButton: FC<ButButtonProps> = ({
  center = false,
  color = 'green',
  children,
  onClick,
  disabled = false,
  analyticKey = '',
  className = '',
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    if (analyticKey) {
      trackYandexGoal(analyticKey);
    }
  };

  return (
    <button
      className={`btn btn-flat btn-flat-${color} btn-flat-rounded ${
        center ? 'center-block' : ''
      } ${disabled ? 'disabled' : ''} ${className}`}
      onClick={handleClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default BuyButton;
